import { Link as RouterLink } from "react-router-dom";
import moment from "moment";
import {
  List,
  ListItem,
  Divider,
  ListItemText,
  Typography,
  Grid,
  Link,
} from "@common-ui/ui";
import { StatusChip } from "../../pages/WorkEvents/StatusChip";

export const RecentWorkList = ({ recentWorkEvents, orgId }) => {
  return (
    <>
      <List sx={{ width: "100%", maxWidth: "100%" }}>
        {recentWorkEvents?.slice(0, 5).map((workEvent) => (
          <RecentWorkEvent
            key={workEvent?.id}
            workEvent={workEvent}
            orgId={orgId}
          />
        ))}
      </List>
    </>
  );
};

const RecentWorkEvent = ({ workEvent, orgId }) => {
  let customerName = workEvent?.for_customer
    ? workEvent?.for_customer?.name?.replace(/(.{15})..+/, "$1...")
    : workEvent?.for_org?.name?.replace(/(.{15})..+/, "$1...");
  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item xs>
          <ListItem
            alignItems="flex-start"
            sx={{ width: "100%", maxWidth: "100%", pl: 0, pr: 0 }}
            style={{ cursor: "pointer", color: "black" }}
            component={RouterLink}
            to={`/work-events/${orgId}/work-event/${workEvent?.id}`}
          >
            <ListItemText
              primary={workEvent?.id}
              secondary={
                <>
                  <Typography
                    sx={{ display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.secondary"
                  >
                    {`${customerName} | ${
                      workEvent?.place ? workEvent?.place : "--"
                    } | ${workEvent?.work_item_last_value} Work Items`}
                  </Typography>
                </>
              }
            />
          </ListItem>
        </Grid>
        <Grid item>
          <ListItem
            alignItems="flex-start"
            sx={{ width: "100%", maxWidth: "100%", pl: 0, pr: 0 }}
            style={{ cursor: "pointer" }}
          >
            <ListItemText
              primary={<StatusChip status={workEvent?.status} />}
              secondary={
                workEvent?.status === "COMPLETED" ? (
                  <Link
                    sx={{ ml: 3, display: "inline" }}
                    component={RouterLink}
                    to={`/reports/performing_org/${orgId}/workevent/${workEvent?.id}`}
                  >
                    View Report
                  </Link>
                ) : (
                  <Typography
                    sx={{ ml: 3, display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.secondary"
                  >
                    {workEvent?.scheduled_start_date !== null
                      ? moment(workEvent?.scheduled_start_date).format(
                          "MM-DD-YYYY"
                        )
                      : ""}
                  </Typography>
                )
              }
            />
          </ListItem>
        </Grid>
      </Grid>
      <Divider variant="middle" />
    </>
  );
};
